import _ from "lodash";

const encodeQuery = (params) => {
	let query = [];

	_.forOwn(params, (value, key) => {
		if (_.isNil(value)) return;
		if (!_.isArray(value)) value = [value];
		value.forEach(val => query.push(`${key}=${val}`));
	});

	return query.join("&");
};

export { encodeQuery };
